var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C10.067 4 8.50002 5.567 8.50002 7.5C8.50002 9.433 10.067 11 12 11C13.933 11 15.5 9.433 15.5 7.5C15.5 5.567 13.933 4 12 4ZM6.50002 7.5C6.50002 4.46243 8.96246 2 12 2C15.0376 2 17.5 4.46243 17.5 7.5C17.5 10.5376 15.0376 13 12 13C8.96246 13 6.50002 10.5376 6.50002 7.5ZM9.32629 14.5C9.38335 14.5 9.44125 14.5 9.50003 14.5H14.5C14.5588 14.5 14.6167 14.5 14.6738 14.5C15.901 14.4995 16.739 14.4992 17.4514 14.7153C19.0495 15.2 20.3 16.4506 20.7847 18.0486C21.0008 18.761 21.0005 19.599 21.0001 20.8263C21 20.8833 21 20.9412 21 21C21 21.5523 20.5523 22 20 22C19.4477 22 19 21.5523 19 21C19 19.5317 18.9892 19.0192 18.8708 18.6291C18.58 17.6703 17.8297 16.92 16.8709 16.6292C16.4808 16.5108 15.9683 16.5 14.5 16.5H9.50003C8.03171 16.5 7.51923 16.5108 7.12917 16.6292C6.17036 16.92 5.42005 17.6703 5.1292 18.6291C5.01088 19.0192 5.00002 19.5317 5.00002 21C5.00002 21.5523 4.55231 22 4.00002 22C3.44774 22 3.00002 21.5523 3.00002 21C3.00002 20.9412 3 20.8833 2.99998 20.8263C2.99953 19.599 2.99922 18.761 3.21532 18.0486C3.70007 16.4506 4.95059 15.2 6.54859 14.7153C7.261 14.4992 8.09902 14.4995 9.32629 14.5Z",
    fill: "#006EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.652fd78cf97c73aca5e5bc0796bcf461.svg";
export { ForwardRef as ReactComponent };